import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { HUB_PATH } from '../config';
import SiteFooter from './SiteFooter';
import './Rules.css';

/** Standalone rules screen: no game chrome, just a close button back to where it was opened. */
function RulesPage({ gameTitle, playTo, children }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleClose = () => {
    // Opened from a direct link there is nothing to go back to inside the app.
    if ((window.history.state?.idx ?? 0) > 0) {
      navigate(-1);
    } else {
      navigate(user ? HUB_PATH : '/login', { replace: true });
    }
  };

  return (
    <div className="rules-page">
      <header className="rules-page__top">
        <div className="rules-page__heading">
          <span className="rules-page__kicker">Правила</span>
          <h1 className="rules-page__title">{gameTitle}</h1>
        </div>
        <button
          type="button"
          className="rules-page__close"
          onClick={handleClose}
          aria-label="Закрыть правила"
          title="Закрыть"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M6 6l12 12M18 6L6 18"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </header>
      <main>
        {children}
        <div className="rules-page__actions">
          <Link to={HUB_PATH} className="btn btn-secondary">
            На главную
          </Link>
          <Link to={playTo} className="btn btn-primary">
            Играть
          </Link>
        </div>
      </main>
      <SiteFooter rules={[]} />
    </div>
  );
}

export default RulesPage;
